module.exports = __webpack_public_path__ + "static/media/isg.aff38fcc.jpg";